const config = {
  calendar: '行事曆',
  recent_interview: '最近面試',
  Month: '月份',
  Week: '週',
  Day: '日',
  Agenda: '列表',
  today: '今天',
};

export default config;
